import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCategories } from '../ActionCreators';
import { ICategory } from '../../models/ICategory';

interface ICategoriesState {
	categories: ICategory[];
	isLoading: boolean;
	error: string;
}
const initialState: ICategoriesState = {
	categories: [],
	isLoading: false,
	error: null,
};

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: {},
	extraReducers: {
		[fetchCategories.fulfilled.type]: (state, action: PayloadAction<ICategory[]>) => {
			state.isLoading = false;
			state.error = null;
			state.categories = action.payload;
		},
		[fetchCategories.pending.type]: (state) => {
			state.isLoading = true;
		},
		[fetchCategories.rejected.type]: (state, action: PayloadAction<string>) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default categoriesSlice.reducer;
